import * as RadixRadioGroup from '@radix-ui/react-radio-group'
import { cx } from 'class-variance-authority'
import type { ComponentPropsWithoutRef } from 'react'
import * as React from 'react'
import { forwardRef } from 'react'

import styles from './RadioGroup.module.scss'

export interface RadioGroupProps
  extends ComponentPropsWithoutRef<typeof RadixRadioGroup.Root> {
  className?: string
}

export const RadioGroup = forwardRef<
  React.ElementRef<typeof RadixRadioGroup.Root>,
  RadioGroupProps
>(({ className, children, ...props }, ref) => (
  <RadixRadioGroup.Root
    className={cx(styles.root, className)}
    ref={ref}
    {...props}
  >
    {children}
  </RadixRadioGroup.Root>
))
RadioGroup.displayName = 'RadioGroup'

export interface RadioItemProps
  extends Omit<
    ComponentPropsWithoutRef<typeof RadixRadioGroup.Item>,
    'children'
  > {
  label: string
  className?: string
  warning?: boolean
}

export const RadioItem = forwardRef<HTMLButtonElement, RadioItemProps>(
  ({ value, label, className, warning = false, ...props }, ref) => (
    <label className={cx(styles.wrapper, className)} data-warning={warning}>
      <RadixRadioGroup.Item
        className={styles.item}
        data-warning={warning}
        ref={ref}
        value={value}
        {...props}
      >
        <RadixRadioGroup.Indicator
          className={styles.indicator}
          data-warning={warning}
        />
      </RadixRadioGroup.Item>
      <span className={styles.label}>{label}</span>
    </label>
  )
)
RadioItem.displayName = 'RadioGroup.Item'

export const Radio = {
  Group: RadioGroup,
  Item: RadioItem
}
